<template>

    <!-- Application container -->
    <!-- Contains all the components of the application -->
    <router-view id="app" />

</template>

<script>
export default {
    name: "App",
};
</script>

